import useWidth from '@/helpers/widthUtil';
import { Skeleton } from 'antd';
import { MathJax } from 'better-react-mathjax';
import Image from 'next/image';
import React from 'react';
import { FacebookShareButton, TwitterShareButton } from 'react-share';
import BlogSidebar from './BlogSidebar';

function SingleBlogContent({ blog, loading }) {
  const blogUrl = `${process.env.NEXT_PUBLIC_SITE_URL}blog/${blog?.slug}`;
  const { isMobile } = useWidth();
  return (
    <section className={`blog-details-area ${isMobile ? 'mb-4 pt-3' : 'pt-5 pb-5'}`}>
      <div className="custom-container">
        <div className="row">
          <div className="col-lg-8 col-md-12">
            <div className="custom-box-shadow custom-rounded blog-page-card mb-3 p-4">
              <div className="blog-details-desc">
                {!isMobile ? (
                  <div className="article-image">
                    {
                      <Image
                        src={blog?.photo || '/images/saas-image/reducedimage.webp'}
                        alt="image"
                        width="800px"
                        height="320px"
                        className="animate__animated animate__fadeInUp animate__delay-0.5s tranform-up-hover box-shadow-hover"
                        priority
                      />
                      // )
                    }
                  </div>
                ) : (
                  <Image
                    src={blog?.photo || '/images/saas-image/reducedimage.webp'}
                    alt="image"
                    width="800px"
                    height="320px"
                    className="animate__animated animate__fadeInUp animate__delay-0.5s tranform-up-hover box-shadow-hover border-14"
                    priority
                  />
                )}
                {/* Article details content */}
                <div className="article-content mt-0">
                  <h3 className="font-weight-bold">{blog?.title}</h3>
                  <div className="entry-meta font-italic mb-2">
                    <ul>
                      <li className="font-weight-normal text-muted">
                        {loading ? (
                          <Skeleton.Button
                            active={true}
                            size={'default'}
                            shape={'round'}
                          />
                        ) : (
                          <div>
                            {' '}
                            <span className="mr-1 font-weight-normal text-muted">
                              Posted On:
                            </span>{' '}
                            {new Date(blog?.publish).toDateString()}
                          </div>
                        )}
                      </li>
                      <li className="font-weight-normal text-muted">
                        {loading ? (
                          <Skeleton.Button
                            active={true}
                            size={'default'}
                            shape={'round'}
                          />
                        ) : (
                          <>
                            {' '}
                            <span className="mr-1 font-weight-normal text-muted">
                              Posted By:
                            </span>{' '}
                            {blog?.author?.name}{' '}
                          </>
                        )}
                      </li>
                    </ul>
                  </div>
                  {loading ? (
                    <>
                      <Skeleton active />
                      <Skeleton active />
                    </>
                  ) : (
                    <>
                      <MathJax inline dynamic>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: blog?.content,
                          }}
                          id="notes-description"
                        ></div>
                      </MathJax>
                    </>
                  )}
                </div>
              </div>
              <div className="widget mt-5">
                <h5 className="text-primary widget-title">Share On</h5>
                <ul className="list-unstyled social-icon mt-4 mb-0">
                  <li className="list-inline-item mr-1">
                    <a className="rounded">
                      <FacebookShareButton url={blogUrl} hashtag={'learnsic'}>
                        <i className="fab fa-facebook"></i>
                      </FacebookShareButton>
                    </a>
                  </li>
                  <li className="list-inline-item mr-1">
                    <a className="rounded">
                      <TwitterShareButton
                        url={blogUrl}
                        hashtags={['blog', 'learnsic']}
                      >
                        <i className="fab fa-twitter"></i>
                      </TwitterShareButton>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Blog Sidebar */}
          <div className="col-lg-4 col-md-12">
            <div className="">
              <BlogSidebar blog={blog} loading={loading} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SingleBlogContent;
